var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"discovery-teaser"},[_c('div',{staticClass:"discovery-teaser-image"},[_c('img',_vm._b({},'img',_vm.img,false)),_c('div',{staticClass:"image-overlay"},[_c('div',[_vm._v(_vm._s(_vm.text)+" "),_c('lazy-icon',{attrs:{"icon":"arrow-long-right"}})],1)])]),_c('div',{staticClass:"disovery-teaser-content pb-5"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }